var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { GiphyFetch, setServerUrl } from "@giphy/js-fetch-api";
import { Grid } from "@giphy/react-components";
import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { batch, useDispatch, useSelector } from "react-redux";
import { makeStyles } from "tss-react/mui";
import { createGifSentEvent } from "../../../analytics/AnalyticsEvents";
import { sendAnalytics } from "../../../analytics/functions";
import { sendMessage } from "../../../chat/actions.any";
import { SCROLL_SIZE } from "../../../filmstrip/constants";
import { toggleReactionsMenuVisibility } from "../../../reactions/actions.web";
import { setGifMenuVisibility } from "../../actions";
import { formatGifUrlMessage, getGifAPIKey, 
// getGifRating,
getGifUrl, getGiphyProxyUrl, } from "../../function.any";
import { SearchParticipantInput } from "../../../participants-pane/components/styled";
const useStyles = makeStyles()((theme) => {
    return {
        gifsMenu: {
            width: "100%",
            marginBottom: 8,
            display: "flex",
            flexDirection: "column",
            "& div:focus": {
                border: "1px solid red !important",
                boxSizing: "border-box",
            },
        },
        searchField: {
            marginBottom: 16,
        },
        gifContainer: {
            height: "245px",
            overflowY: "auto",
        },
        logoContainer: {
            width: `calc(100% - ${SCROLL_SIZE}px)`,
            backgroundColor: "#121119",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            marginTop: 4,
        },
        overflowDrawerMenu: {
            padding: 16,
            width: "100%",
            boxSizing: "border-box",
            height: "100%",
        },
        overflowMenu: {
            height: "300px",
            width: "100%",
            marginBottom: "0px",
        },
        gifContainerOverflow: {
            flexGrow: 1,
        },
        drawer: {
            display: "flex",
            height: "100%",
        },
    };
});
/**
 * Gifs menu.
 *
 * @returns {ReactElement}
 */
function GifsMenu({ columns = 2, parent }) {
    const API_KEY = useSelector(getGifAPIKey);
    const giphyFetch = new GiphyFetch(API_KEY);
    const [searchKey, setSearchKey] = useState();
    const { classes: styles, cx } = useStyles();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    // const isInOverflowMenu
    //     = parent === IReactionsMenuParent.OverflowDrawer || parent === IReactionsMenuParent.OverflowMenu;
    const isInOverflowMenu = true;
    const { clientWidth } = useSelector((state) => state["features/base/responsive-ui"]);
    const proxyUrl = useSelector(getGiphyProxyUrl);
    const fetchGifs = useCallback((...args_1) => __awaiter(this, [...args_1], void 0, function* (offset = 0) {
        const options = {
            limit: 20,
            offset,
        };
        if (!searchKey) {
            return yield giphyFetch.trending(options);
        }
        return yield giphyFetch.search(searchKey, options);
    }), [searchKey]);
    const onDrawerClose = useCallback(() => {
        dispatch(setGifMenuVisibility(false));
    }, []);
    const handleGifClick = useCallback((gif, e) => {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        const url = getGifUrl(gif, proxyUrl);
        sendAnalytics(createGifSentEvent());
        batch(() => {
            dispatch(sendMessage(formatGifUrlMessage(url), true));
            dispatch(toggleReactionsMenuVisibility());
            isInOverflowMenu && onDrawerClose();
        });
    }, [dispatch, isInOverflowMenu]);
    const handleGifKeyPress = useCallback((gif, e) => {
        if (e.nativeEvent.keyCode === 13) {
            handleGifClick(gif, null);
        }
    }, [handleGifClick]);
    const handleSearchKeyChange = useCallback((value) => {
        setSearchKey(value);
    }, []);
    const handleKeyDown = useCallback((e) => {
        if (!document.activeElement) {
            return;
        }
        if (e.keyCode === 38) {
            // up arrow
            e.preventDefault();
            // if the first gif is focused move focus to the input
            if (document.activeElement.previousElementSibling === null) {
                const element = document.querySelector(".gif-input");
                element === null || element === void 0 ? void 0 : element.focus();
            }
            else {
                const element = document.activeElement
                    .previousElementSibling;
                element === null || element === void 0 ? void 0 : element.focus();
            }
        }
        else if (e.keyCode === 40) {
            // down arrow
            e.preventDefault();
            // if the input is focused move focus to the first gif
            if (document.activeElement.classList.contains("gif-input")) {
                const element = document.querySelector(".giphy-gif");
                element === null || element === void 0 ? void 0 : element.focus();
            }
            else {
                const element = document.activeElement
                    .nextElementSibling;
                element === null || element === void 0 ? void 0 : element.focus();
            }
        }
    }, []);
    useEffect(() => {
        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, []);
    // For some reason, the Grid component does not do an initial call on mobile.
    // This fixes that.
    useEffect(() => setSearchKey(""), []);
    useEffect(() => {
        if (proxyUrl) {
            setServerUrl(proxyUrl);
        }
    }, []);
    const onInputKeyPress = useCallback((e) => {
        e.stopPropagation();
    }, []);
    return (React.createElement("div", { className: cx(styles.gifsMenu, styles.overflowMenu) },
        React.createElement(SearchParticipantInput, { autoFocus: true, className: cx(styles.searchField, "gif-input"), id: "gif-search-input", onChange: (e) => handleSearchKeyChange(e.target.value), onKeyPress: onInputKeyPress, placeholder: t("giphy.search"), type: "text", value: searchKey !== null && searchKey !== void 0 ? searchKey : "" }),
        React.createElement("div", { className: cx(styles.gifContainer) },
            React.createElement(Grid, { columns: columns, fetchGifs: fetchGifs, gutter: 6, hideAttribution: true, key: searchKey, noLink: true, noResultsMessage: t("giphy.noResults"), onGifClick: handleGifClick, onGifKeyPress: handleGifKeyPress, width: 270 })),
        React.createElement("div", { className: styles.logoContainer },
            React.createElement("span", null, "Powered by"),
            React.createElement("img", { alt: "GIPHY Logo", src: "images/GIPHY_logo.png" }))));
}
export default GifsMenu;
